import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import TextAreaField from "../../Shared/TextAreaField"

const MessageLocationForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        public_id: "",
        body: "",
        char_counter: 0,
        sms_counter: 1,
    })
    const {public_id, body, char_counter, sms_counter} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const { payload } = location.state;
            setFormData((prev) => ({
                ...prev,
                public_id: payload.public_id
            }));
        }
                
    }, []);


    const onChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            const isBody = name === "body";
            const newBody = isBody ? value : prev.body;
            const charDiff = isBody ? newBody.length - prev.body.length : 0;
            return {
                ...prev,
                [name]: value,
                char_counter: isBody ? Math.max(0, prev.char_counter + charDiff) : prev.char_counter,
                sms_counter: isBody ? Math.ceil(newBody.length / 160) : prev.sms_counter,
            }
        })
    }

    const onSubmit = (e) => {
        e.preventDefault()

        sendMessage({public_id, body})
    }
    
    const sendMessage = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post(`/messages/location/${payload.public_id}/send`, {body: payload.body})
            toast.success(response?.data?.detail)
            navigate(`/locations-serverside`)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Message Location Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-12 p-4">
                            <TextAreaField
                                placeholder="160 characters(xaraf) costs 1 sms"
                                name="body"
                                type="text"
                                label="Message Bory"
                                required="required"
                                value={body}
                                onChange={onChange}
                                error={errors.body}
                            />
                            <span className="text-orange h3" style={{float: 'right', marginRight: '20px'}}>{`Characters: ${char_counter}, SMS: ${sms_counter}`}</span>
                        </div>
                        
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Send Message" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default MessageLocationForm
